"use client";

import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurMission() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="255655" id="מיקומים-וביתנות-בבאר-שבע" className="bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={leftRef} className={`lg:col-span-7 space-y-6 md:space-y-8 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-primary tracking-tight">
                שירותי סיעוד בבאר שבע והסביבה
              </h2>
              <div className="w-20 h-1.5 bg-secondary rounded-lg"></div>
            </div>
            
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl font-default">
              אנו מספקים מענה סיעודי מקצועי ומהיר בבאר שבע, עם דגש על ליווי צמוד בבית החולים סורוקה ובבית המטופל. הצוות שלנו ערוך להעניק טיפול מסור ומיומן תוך 5 שעות בלבד מרגע הפנייה, כדי להבטיח שקט נפשי למשפחה וטיפול מיטבי ליקיריכם בבירת הנגב.
            </p>
            
            <div className="pt-4">
              <Button size="lg" className="text-base px-8 h-14 rounded-lg shadow-md hover:shadow-lg transition-all bg-primary text-primary-foreground font-default">
                למידע נוסף על השירות
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 transition-all duration-1000 delay-200 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative group rounded-lg overflow-hidden shadow-xl border border-border/50 bg-muted">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/beersheva_medical_care.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/beersheva_medical_care.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/beersheva_medical_care.png-wvc-sizes" alt="צוות סיעודי בבאר שבע - מרכז רפואי סורוקה" className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/20 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-90" />

                {}
                <div className="absolute inset-0 flex items-center justify-center">
                  <Button variant="default" size="icon" className="size-16 md:size-20 rounded-lg shadow-xl backdrop-blur-sm bg-secondary/90 hover:bg-secondary hover:scale-110 transition-all duration-300 border-2 border-white/20" aria-label="צפו בסרטון השירות בבאר שבע">
                    <Play className="size-8 md:size-10 ml-1 text-secondary-foreground" fill="currentColor" />
                  </Button>
                </div>

                {}
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 transform transition-transform duration-500 translate-y-2 group-hover:translate-y-0">
                  <h3 className="text-white font-default font-semibold text-xl md:text-2xl leading-tight drop-shadow-md">
                    ליווי רפואי וסיעודי בבאר שבע: מהבית ועד סורוקה
                  </h3>
                </div>
              </AspectRatio>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}